<template>
    <div class="notification-view-modal" v-if="notification">
        <b-modal hide-footer
                 title="New Message"
                 :id="modalId">
            <table class="mb-3">
                <tr>
                    <th>Message</th>
                    <td v-html="notification.message"/>
                </tr>
                <tr>
                    <th>Sent</th>
                    <td>
                        <timestamp :date="notification.created"/>
                    </td>
                </tr>

                <tr v-if="notification.audit_id">
                    <th>Audit</th>
                    <td>
                        <router-link :to="`/audit/edit/${notification.audit_id}`">
                            View Audit
                        </router-link>
                    </td>
                </tr>

                <tr v-if="notification.equipment_id">
                    <th>Equipment</th>
                    <td>
                        <router-link :to="`/equipment/view/${notification.equipment_id}`">
                            View Equipment
                        </router-link>
                    </td>
                </tr>

                <tr v-if="notification.project_id">
                    <th>Project</th>
                    <td>
                        <router-link :to="`/project/view/${notification.project_id}`">
                            View Project
                        </router-link>
                    </td>
                </tr>
            </table>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'NotificationViewModal',
    props: {
        notification: Object,
        modalId: String,
    }
}
</script>
